/** Algerian formatting rules (PRD §14 Localisation): 1 982 100,00 DA — dd/MM/yyyy. */
const NBSP = " ";
export function formatDA(value, opts = {}) {
    const { decimals = 2, symbol = "DA" } = opts;
    const fixed = Math.abs(value).toFixed(decimals);
    const [int, frac] = fixed.split(".");
    const grouped = (int ?? "0").replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
    const sign = value < 0 ? "-" : "";
    return `${sign}${grouped}${frac ? "," + frac : ""}${NBSP}${symbol}`;
}
export function formatPercent(fraction) {
    return `${Math.round(fraction * 100)}${NBSP}%`;
}
/** Calendar dates keep their day in every timezone; Date objects represent local timestamps. */
export function formatDate(value) {
    if (typeof value === "string") {
        const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
        const french = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
        if (iso || french) {
            const [year, month, day] = iso
                ? [Number(iso[1]), Number(iso[2]), Number(iso[3])]
                : [Number(french[3]), Number(french[2]), Number(french[1])];
            const check = new Date(0);
            check.setUTCFullYear(year, month - 1, day);
            if (year < 1 || check.getUTCFullYear() !== year || check.getUTCMonth() + 1 !== month || check.getUTCDate() !== day) {
                throw new RangeError("Invalid calendar date");
            }
            return `${String(day).padStart(2, "0")}/${String(month).padStart(2, "0")}/${String(year).padStart(4, "0")}`;
        }
        // Only ISO timestamps may use Date parsing; dd/MM/yyyy is handled explicitly above.
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value))
            throw new RangeError("Unsupported date format");
    }
    const d = value instanceof Date ? value : new Date(value);
    if (!Number.isFinite(d.getTime()))
        throw new RangeError("Invalid date");
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mm}/${d.getFullYear()}`;
}
/** Western → Arabic-Indic digits, for the optional AR numerals setting. */
export function toArabicIndic(s) {
    return s.replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[Number(d)] ?? d);
}
//# sourceMappingURL=format.js.map